const DEFAULT_STATE = {
  scrollPosY: 0
}

export const types = {
  SET_SCROLL_POS_Y: 'gulftree/ui/SET_SCROLL_POS_Y'
}

export default function reducer(state = DEFAULT_STATE, action = {}) {
  switch (action.type) {

    case types.SET_SCROLL_POS_Y:
      return {
        ...state,
        scrollPosY: action.payload
      }

    default:
      return state
  }
}

export function setScrollPosY(val) {
  return {
    type: types.SET_SCROLL_POS_Y,
    payload: val
  }
}
